module.exports = __webpack_public_path__ + "static/backYellow-fd42f125cbe2824de0eeea4c0afc629c.png";